// SEO data for all pages

// Static pages SEO
export const PAGES_SEO = {
  home: {
    title: 'Antiquaire Expert Paris | Rachat Antiquites - Stephane Weinrich',
    description: 'Antiquaire expert a Paris, Stephane Weinrich rachete vos antiquites, bijoux, mobilier ancien. Estimation gratuite a domicile en Ile-de-France. 3 generations d\'expertise.',
    path: '/',
  },
  about: {
    title: 'A Propos | Antiquaire Expert Paris - Stephane Weinrich',
    description: 'Decouvrez Stephane Weinrich, antiquaire expert depuis 3 generations. Expertise en antiquites, mobilier ancien et objets d\'art a Paris et Ile-de-France.',
    path: '/about',
  },
  contact: {
    title: 'Contact | Antiquaire Expert Paris - Estimation Gratuite',
    description: 'Contactez notre antiquaire expert a Paris. Estimation gratuite, deplacement a domicile en Ile-de-France. Tel: 06 58 08 45 16',
    path: '/contact',
  },
  services: {
    title: 'Nos Services | Rachat, Debarras & Estimation Antiquites',
    description: 'Services d\'antiquaire a Paris: rachat d\'antiquites, debarras de succession, estimation gratuite a domicile. Paiement immediat, deplacement gratuit.',
    path: '/services',
  },
  objets: {
    title: 'Objets Rachetes | Antiquaire Expert Paris',
    description: 'Decouvrez tous les objets que nous rachetons: mobilier ancien, bijoux, horlogerie, argenterie, art, porcelaine, sculptures et plus encore.',
    path: '/objets',
  },
  testimonials: {
    title: 'Temoignages Clients | Antiquaire Expert Paris',
    description: 'Avis et temoignages de nos clients satisfaits. Decouvrez leur experience avec notre service de rachat d\'antiquites a Paris et Ile-de-France.',
    path: '/temoignages',
  },
  estimation: {
    title: 'Estimation Gratuite | Antiquaire Expert',
    description: 'Estimation gratuite de vos antiquites a domicile. Expert antiquaire se deplace a Paris et Ile-de-France. Reponse rapide, paiement immediat.',
    path: '/estimation-offerte',
  },
  zones: {
    title: 'Zones d\'Intervention | Antiquaire Paris Ile-de-France',
    description: 'Zones d\'intervention: Paris (75), Seine-et-Marne (77), Yvelines (78), Essonne (91), Seine-Saint-Denis (93), Val-de-Marne (94). Deplacement gratuit.',
    path: '/zone-d-intervention',
  },
};

// Category pages SEO (21 categories)
export const CATEGORIES_SEO = {
  mobilier: {
    title: 'Rachat Mobilier Ancien | Antiquaire Expert Paris',
    description: 'Rachat de mobilier ancien a Paris: commodes, secretaires, buffets, tables Louis XV, XVI, Empire, Art Deco. Estimation gratuite, paiement comptant.',
    path: '/mobilier',
  },
  bijoux: {
    title: 'Rachat Bijoux Anciens | Or, Diamants - Antiquaire Paris',
    description: 'Achat de bijoux anciens a Paris: bagues, colliers, bracelets en or, diamants, pierres precieuses. Expertise gratuite, meilleurs prix.',
    path: '/bijoux',
  },
  horlogerie: {
    title: 'Rachat Montres & Horlogerie | Antiquaire Expert Paris',
    description: 'Achat montres anciennes et pendules a Paris. Rolex, Patek Philippe, Omega, montres gousset, pendules comtoises. Expertise gratuite.',
    path: '/horlogerie',
  },
  art: {
    title: 'Rachat Tableaux & Oeuvres d\'Art | Antiquaire Paris',
    description: 'Achat tableaux anciens, peintures, gravures et objets d\'art a Paris. Expertise gratuite, estimation professionnelle de vos oeuvres.',
    path: '/art',
  },
  argenterie: {
    title: 'Rachat Argenterie | Argent Massif - Antiquaire Paris',
    description: 'Achat argenterie a Paris: couverts, services, objets en argent massif. Estimation gratuite, meilleurs prix pour votre argenterie ancienne.',
    path: '/argenterie',
  },
  porcelaine: {
    title: 'Rachat Porcelaine Ancienne | Sevres, Limoges - Paris',
    description: 'Achat porcelaine ancienne a Paris: Sevres, Limoges, Meissen, services de table. Estimation gratuite de vos pieces de collection.',
    path: '/porcelaine',
  },
  sculpture: {
    title: 'Rachat Sculptures | Bronze, Marbre - Antiquaire Paris',
    description: 'Achat sculptures anciennes a Paris: bronzes, marbres, terres cuites, bois sculptes. Expertise gratuite par antiquaire professionnel.',
    path: '/sculpture',
  },
  'arts-asiatiques': {
    title: 'Rachat Arts Asiatiques | Chine, Japon - Antiquaire Paris',
    description: 'Achat art asiatique a Paris: porcelaine chinoise, bronzes japonais, laques, estampes, jades. Expert en antiquites d\'Asie.',
    path: '/arts-asiatiques',
  },
  tapisserie: {
    title: 'Rachat Tapisseries & Tapis Anciens | Antiquaire Paris',
    description: 'Achat tapisseries et tapis anciens a Paris: Aubusson, Gobelins, tapis d\'Orient. Expertise gratuite, deplacement a domicile.',
    path: '/tapisserie',
  },
  jouets: {
    title: 'Rachat Jouets Anciens | Collection - Antiquaire Paris',
    description: 'Achat jouets anciens a Paris: trains miniatures, poupees, automates, jouets en tole, Dinky Toys. Estimation gratuite.',
    path: '/jouets',
  },
  militaire: {
    title: 'Rachat Militaria | Objets Militaires - Antiquaire Paris',
    description: 'Achat militaria a Paris: uniformes, medailles, sabres, casques, decorations, documents. Expert en objets militaires anciens.',
    path: '/militaire',
  },
  livres: {
    title: 'Rachat Livres Anciens | Bibliophilie - Antiquaire Paris',
    description: 'Achat livres anciens a Paris: editions rares, manuscrits, reliures d\'art, gravures anciennes. Expertise gratuite de votre bibliotheque.',
    path: '/livres',
  },
  'instrument-de-musique': {
    title: 'Rachat Instruments de Musique Anciens | Paris',
    description: 'Achat instruments de musique anciens a Paris: violons, guitares, pianos, instruments a vent. Expertise gratuite par antiquaire.',
    path: '/instrument-de-musique',
  },
  ceramiques: {
    title: 'Rachat Ceramiques & Faiences | Antiquaire Paris',
    description: 'Achat ceramiques anciennes a Paris: faiences regionales, gres, barbotines, majoliques. Estimation gratuite de vos pieces.',
    path: '/ceramiques',
  },
  'vin-et-spiritueux': {
    title: 'Rachat Vins Anciens & Spiritueux | Cave - Paris',
    description: 'Achat vins anciens et spiritueux a Paris: grands crus, cognacs, armagnacs, whiskies de collection. Estimation gratuite de votre cave.',
    path: '/vin-et-spiritueux',
  },
  voitures: {
    title: 'Rachat Voitures Anciennes | Collection - Paris',
    description: 'Achat voitures anciennes et de collection a Paris. Expertise gratuite, estimation professionnelle de vehicules anciens.',
    path: '/voitures',
  },
  monnaie: {
    title: 'Rachat Monnaies & Medailles | Numismatique - Paris',
    description: 'Achat pieces de monnaie anciennes, medailles et jetons a Paris. Expert numismatique, estimation gratuite de vos collections.',
    path: '/monnaie',
  },
  'luxe-maroquinerie': {
    title: 'Rachat Sacs de Luxe | Hermes, Chanel - Paris',
    description: 'Achat sacs de luxe a Paris: Hermes, Chanel, Louis Vuitton, Dior. Estimation gratuite de votre maroquinerie de luxe.',
    path: '/luxe-maroquinerie',
  },
  fourrures: {
    title: 'Rachat Fourrures | Vison, Astrakan - Paris',
    description: 'Achat fourrures a Paris: vison, astrakan, renard, chinchilla. Estimation gratuite de vos manteaux et vetements de fourrure.',
    path: '/fourrures',
  },
  'vehicules-anciens': {
    title: 'Rachat Vehicules Anciens | Motos, Voitures - Paris',
    description: 'Achat vehicules anciens a Paris: voitures de collection, motos anciennes, vehicules militaires. Expertise gratuite.',
    path: '/vehicules-anciens',
  },
  numismatique: {
    title: 'Rachat Numismatique | Pieces, Billets - Paris',
    description: 'Achat numismatique a Paris: pieces anciennes, billets de collection, medailles commemoratives. Estimation gratuite.',
    path: '/numismatique',
  },
};

// Zone pages SEO (6 departments)
export const ZONES_SEO = {
  '75': {
    title: 'Antiquaire Paris 75 | Tous Arrondissements',
    description: 'Antiquaire expert dans tout Paris (75). Estimation gratuite a domicile dans les 20 arrondissements. Rachat antiquites, bijoux, mobilier ancien.',
    path: '/zone-d-intervention/75',
  },
  '77': {
    title: 'Antiquaire Seine-et-Marne 77 | Meaux, Melun',
    description: 'Antiquaire expert en Seine-et-Marne (77). Deplacement gratuit a Meaux, Melun, Fontainebleau, Chelles. Rachat antiquites a domicile.',
    path: '/zone-d-intervention/77',
  },
  '78': {
    title: 'Antiquaire Yvelines 78 | Versailles, Saint-Germain',
    description: 'Antiquaire expert dans les Yvelines (78). Intervention a Versailles, Saint-Germain-en-Laye, Poissy. Estimation gratuite.',
    path: '/zone-d-intervention/78',
  },
  '91': {
    title: 'Antiquaire Essonne 91 | Evry, Corbeil',
    description: 'Antiquaire expert en Essonne (91). Deplacement gratuit a Evry, Corbeil-Essonnes, Massy. Rachat antiquites a domicile.',
    path: '/zone-d-intervention/91',
  },
  '93': {
    title: 'Antiquaire Seine-Saint-Denis 93 | Saint-Denis, Montreuil',
    description: 'Antiquaire expert en Seine-Saint-Denis (93). Estimation gratuite a Saint-Denis, Montreuil, Bobigny. Rachat tous objets anciens.',
    path: '/zone-d-intervention/93',
  },
  '94': {
    title: 'Antiquaire Val-de-Marne 94 | Creteil, Vincennes',
    description: 'Antiquaire expert dans le Val-de-Marne (94). Intervention a Creteil, Vincennes, Saint-Maur. Estimation et rachat gratuit.',
    path: '/zone-d-intervention/94',
  },
};

// Helper functions
export const getPageSEO = (key) => PAGES_SEO[key] || null;
export const getCategorySEO = (key) => CATEGORIES_SEO[key] || null;
export const getZoneSEO = (deptCode) => ZONES_SEO[deptCode] || null;
